import {ApiConfig} from "components/src/api/portal/ApiConfig";
import {EnterprisePortalApi, LimitedEnterprisePortalProperties} from "components/src/api/portal/generated";
import {createContext, useEffect, useMemo, useState} from "react";

const enterprisePortalApi = new EnterprisePortalApi(ApiConfig.config());

export interface IEnterprisePortalPropertiesContext {
    properties: LimitedEnterprisePortalProperties | undefined;
}

export const EnterprisePortalPropertiesContext = createContext<IEnterprisePortalPropertiesContext | undefined>(undefined);

interface EnterprisePortalPropertiesContextProviderProps {
    children: React.ReactNode;
}

export function EnterprisePortalPropertiesContextProvider({children}: Readonly<EnterprisePortalPropertiesContextProviderProps>)
{
    const [properties, setProperties] = useState<LimitedEnterprisePortalProperties | undefined>(undefined);

    useEffect(() =>
    {
        enterprisePortalApi.enterprisePortalControllerGetEnterprisePortalProperties()
            .then(response => setProperties(response.data))
            .catch(() => { /* auth is handled by AuthenticatedRoute */ });
    }, []);

    const exposedData = useMemo<IEnterprisePortalPropertiesContext>(() => ({properties}), [properties]);

    return (
        <EnterprisePortalPropertiesContext.Provider value={exposedData}>
            {children}
        </EnterprisePortalPropertiesContext.Provider>
    );
}
